export default __webpack_public_path__ + "static/media/kasbon.b5778d0a.png";